import * as React from 'react'

import { Loading } from '../../../components/loading'
import ViewFooter from '../components/ViewFooter'
import { OptionsLoaderData } from '../types'

const ScatterPlot = React.lazy(() => import('../components/ScatterPlot'))

export function PlotRoute({ options }: OptionsLoaderData) {
  return (
    <>
      <div className="mx-auto w-5/6 pb-4 pt-4">
        <div className="flex h-[700px] justify-center rounded-md border border-primary">
          <React.Suspense
            fallback={
              <div className="flex h-full flex-col items-center justify-center">
                <Loading />
              </div>
            }
          >
            <ScatterPlot data={options} />
          </React.Suspense>
        </div>
        <ViewFooter />
      </div>
    </>
  )
}
